// SSE Event Type Constants
export const SSE_EVENT_TYPES = {
  // Connection Events
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  HEARTBEAT: 'heartbeat',
  ERROR: 'error',

  // Validation Events
  VALIDATION: 'validation',
  VALIDATION_ERROR: 'validationError',

  // Processing Events
  PROCESSING: 'processing',
  PROCESSING_PROGRESS: 'ProcessingProgress',

  // Upload Events
  UPLOADING: 'uploading',
  UPLOAD_COMPLETE: 'uploadComplete',

  // Product Events
  PRODUCT_IMPORT: 'productimport',
  PRODUCT_EXPORT: 'productExport',
  PRODUCT_DELETE: 'Product delete',
  PRODUCT_BACKUP: 'productBackup',
  PRODUCT_UPDATE: 'productupdate',
  PRODUCT_UPLOAD_BULK: 'productuploadbulk',

  // Collection Events
  COLLECTION_IMPORT: 'collectionimport',
  COLLECTION_EXPORT: 'collectionExport',
  COLLECTION_DELETE: 'Collection delete',
  COLLECTION_UPLOAD_BULK: 'collectionuploadbulk',

  // Customer Events
  CUSTOMER_IMPORT: 'customerimport',
  CUSTOMER_EXPORT: 'customerExport',
  CUSTOMER_DELETE: 'Customer delete',
  CUSTOMER_UPLOAD_BULK: 'customeruploadbulk',

  // Order Events
  ORDER_IMPORT: 'orderimport',
  ORDER_EXPORT: 'orderExport',
  ORDER_DELETE: 'Order delete',
  ORDER_UPLOAD_BULK: 'orderuploadbulk',

  // Page Events
  PAGE_IMPORT: 'pageimport',
  PAGE_EXPORT: 'pageExport',
  PAGE_DELETE: 'Page delete',
  PAGE_COMPARE: 'pagescompare',
  PAGE_UPLOAD_BULK: 'pageuploadbulk',

  // Metaobject Events
  METAOBJECT_IMPORT: 'metaobjectimport',
  METAOBJECT_EXPORT: 'metaobjectExport',
  METAOBJECT_DELETE: 'Metaobject delete',

  // Metafield Events
  METAFIELD_DELETE: 'Metafield delete',
  METAFIELD_PROCESSING: 'metafieldProcessing',

  // Definition Events
  DEFINITION_IMPORT: 'definitionimport',
  DEFINITION_EXPORT: 'definitionExport',

  // Translation Events
  TRANSLATION_IMPORT: 'translationimport',
  TRANSLATION_EXPORT: 'translationExport',

  // Menu Events
  MENU_IMPORT: 'menuimport',
  MENU_EXPORT: 'menuExport',

  // Task Status Events
  TASK_STATUS: 'task-status',
  TASK_COMPLETED: 'task-completed',
  TASK_FAILED: 'task-failed',
  TASK_CANCELED: 'task-canceled',

  // Filter/Download Events
  FILTER_LIST: 'filterList',
  FILTER_VENDOR_LIST: 'filterVendorList',

  // Bulk Operation Events
  BULK_OPERATION_STATUS: 'bulkOperationStatus',
  BULK_OPERATION_COMPLETED: 'bulkOperationCompleted',
  BULK_OPERATION_FAILED: 'bulkOperationFailed'
};

// SSE Connection States
export const SSE_CONNECTION_STATES = {
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  ERROR: 'error',
  RECONNECTING: 'reconnecting'
};

// SSE Configuration
export const SSE_CONFIG = {
  RETRY_DELAY: 5000,
  MAX_RETRY_ATTEMPTS: 5,
  HEARTBEAT_INTERVAL: 30000,
  CONNECTION_TIMEOUT: 60000
};
